import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthProvider';
import { LoadingFallback } from './LoadingFallback';

interface RequireRoleProps {
  children: ReactNode;
  role: string | string[];
}

export const RequireRole = ({ children, role }: RequireRoleProps) => {
  const { user, userRole, loading } = useAuth();

  if (loading) {
    return <LoadingFallback message="Checking permissions..." />;
  }

  if (!user) {
    return <Navigate to="/auth" replace />;
  }

  if (!userRole) {
    // User has no role assigned
    return <Navigate to="/unauthorized" replace />;
  }

  // Admin has access to everything
  if (userRole === 'admin') {
    return <>{children}</>;
  }

  // Check if user's role matches required role(s)
  const allowedRoles = Array.isArray(role) ? role : [role];
  if (!allowedRoles.includes(userRole)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <>{children}</>;
};